import { render, staticRenderFns } from "./subject.vue?vue&type=template&id=ef8998a4&scoped=true&"
import script from "./subject.vue?vue&type=script&lang=js&"
export * from "./subject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8998a4",
  null
  
)

export default component.exports